<template>
  <div class="app">
    <h1>新闻资讯</h1>
    <Header :activeIndex="'9'" />

    <nav class="tiaozhuan" aria-label="面包屑导航"><router-link to="/" style="cursor: pointer; color: inherit; text-decoration: none;"
        >首页</router-link><span>&nbsp;&gt;&gt;&nbsp;</span><span>老板学院</span></nav>
    <main class="margintop">
      <table class="tableCSS">
        <tbody>
          <tr v-for="(news, index) in newsList" :key="news.id">
            <td class="tdCSS1">{{ news.createTime }}</td>
            <td class="tdCSS">
              <a style="cursor: pointer;" @click="handleClick(news.id, getPreviousId(index), getNextId(index))">{{
                news.title }}</a>
            </td>
            <td class="tdCSS">
              <a class="look" style="cursor: pointer;"
                @click="handleClick(news.id, getPreviousId(index), getNextId(index))" title="查 看">查 看</a>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="showContent" v-html="formattedContent"></div>
      <div class="yema">
        <el-pagination layout="prev, pager, next, total" :total="total" :page-size="15" ref="pagination"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </main>

    <Footer />
  </div>
</template>


<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'xueyuan',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      imgCount: 0,
      currentIndex: 0,
      intervalID: '',
      newsList: [],
      currentPage: 1,
      total: 0,
      showContent: '',
      pppclose: true,
      beforefont: '',
    }
  },
  mounted() {
    this.addFAQPageSchema();
    this.fetchNews();
    window.scrollTo(0, 0);
    this.$root.showData.showData = false;
  },

  beforeDestroy() {
    const faqSchema = document.getElementById('faqpage-schema');
    if (faqSchema) {
      faqSchema.remove();
    }
  },

  methods: {
    addFAQPageSchema() {
      const schemaId = 'faqpage-schema';

      // 避免重复插入
      if (document.getElementById(schemaId)) {
        return;
      }

      const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "@id": "https://mingqicaiwu.com/xueyuan#faq",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "代理记账多少钱一个月？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "小规模200元+，一般纳税人500元+，名企科技的服务都是明码标价，根据业务量和服务内容定价，没有隐形消费。"
            }
          },
          {
            "@type": "Question",
            "name": "注册公司需要哪些材料？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "需要法人身份证正反面照片。"
            }
          },
          {
            "@type": "Question",
            "name": "注册公司最少需要几个人？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "一个人就可以注册公司。"
            }
          },
          {
            "@type": "Question",
            "name": "公司的法人有哪些要求？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "一般要求法人年龄在18岁以上、60岁以下。60岁以上如果有经营经验，也可以作为公司法人。"
            }
          },
          {
            "@type": "Question",
            "name": "没有办公室能注册公司吗？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "可以。名企科技可以帮助客户提供注册地址。"
            }
          },
          {
            "@type": "Question",
            "name": "注册公司多久能拿到营业执照？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "办理营业执照的流程较快，最快一周之内就能拿到营业执照。"
            }
          },
          {
            "@type": "Question",
            "name": "注册公司，办理执照的过程中，法人股东需要到场吗，能全程代办吗？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "不用到场，注册公司可以全程代办。"
            }
          },
          {
            "@type": "Question",
            "name": "从开始注册公司到可以开发票需要多久？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "从开始注册公司到可以开发票，一般需要两到三周。"
            }
          },
          {
            "@type": "Question",
            "name": "注册小规模公司好还是一般纳税人公司好？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "小规模公司和一般纳税人公司各有优缺点，需要根据公司的业务和客户类型综合决定。"
            }
          },
          {
            "@type": "Question",
            "name": "开公司需要交多少税收？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "公司常见的税种有企业所得税、增值税、附加税、印花税、工资的个税等。具体税收需要根据公司的业务情况确定。签合同之前，可以用“名企财务助手”小程序测算一下主要税收。"
            }
          }
        ]
      };

      const script = document.createElement('script');
      script.id = schemaId;
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    },
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp
    },
    getPreviousId(index) {
      if (index > 0) {
        return this.newsList[index - 1].id;
      }
      return null; // 如果没有上一行，返回 null
    },
    // 获取下一行的 ID
    getNextId(index) {
      if (index < this.newsList.length - 1) {
        return this.newsList[index + 1].id;
      }
      return null; // 如果没有下一行，返回 null
    },
    handleClick(id) {
      const contentPageUrl = this.$router.resolve({ name: 'xinwen' }).href;
      const urlWithId = `${contentPageUrl}?id=${id}`;

      // 在新标签页打开带 id 的 URL
      window.open(urlWithId, '_blank');
    },
    // handleClick(id,previousId, nextId) {
    //   const contentPageUrl = this.$router.resolve({ name: 'xinwen' }).href;
    //   const urlWithId = `${contentPageUrl}?id=${id}&previousId=${nextId}&nextId=${previousId}`;

    //   // 在新标签页打开带 id 的 URL
    //   window.open(urlWithId, '_blank');
    // },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.fetchNews()
    },
    fetchNews() {
      // 假设这里是你的后端接口
      fetch(`https://mingqicaiwu.com:8201/admin/news/getTitle/${this.currentPage}/10`)
        .then(response => response.json())
        .then(data => {
          this.total = data.data.total
          this.newsList = data.data.listPage.records
        })
        .catch(error => {
          alert("查询失败，请重新刷新")
          console.error("分页查询出错，原因是", error);
        })
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathRemen() {
      this.$router.push('/remen');
    },
    pathJizhang() {
      this.$router.push('/jizhang')
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxinxi() {
      this.$router.push('/xinxi')
    },
    pathcontact() {
      this.$router.push('/contact')
    }
  }
}
</script>

<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {

  .el-menu--horizontal>.el-menu-item {
    float: left;
    height: 30px !important;
    line-height: 30px !important;
    margin: 0;
  }

  .responsive-carousel el-carousel el-carousel--horizontal {
    height: 128px !important;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }

  .el-pagination {
    white-space: nowrap;
    padding: 0px 5px;
    color: #303133;
    font-weight: 700;
  }
}
</style>

<style scoped>
/* 表格 */
.look {
  display: block;
  width: 57px;
  height: 24px;
  line-height: 26px;
  text-align: center;
  background-color: #d42828;
  color: #fff;
  font-size: 14px;
  border-radius: 12px;
}

.yema {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}

.tableCSS {
  width: 720px;
  overflow: hidden;
  border: 1px solid #ddd;
  border-collapse: collapse;
}

.tdCSS1 {
  width: 84px;
  padding: 8px;
  text-align: center;
  border: none;
  font-size: 18px;
  color: #d22525;
  font-weight: 700;
}

.tdCSS {
  padding: 8px;
  text-align: left;
  border: none;
  font-size: 16px;
}


/* 其他 */
ul,
li {
  margin: 0;
  padding: 0;

}

h1 {
  font-size: 0%;
}

.margintop {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  /* margin-top: 118px; */
  flex-direction: column;
}

.tiaozhuan {
  margin-top: 118px;
  text-align: left;
  margin-bottom: 0.83em;
  font-size: 18px;
  margin-left: 19.5%;
  font-weight: 500;
}


@media (max-width: 768px) {

  /* 表格 */
  .look {
    display: block;
    width: 40px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background: #d42828;
    color: #fff;
    font-size: 12px;
    border-radius: 4px;
  }

  .yema {
    margin-top: 1vh;
    margin-left: auto;
    margin-right: auto;
  }

  .tableCSS {
    width: 90%;
    overflow: hidden;
    margin-top: 3px;
    border: 1px solid #ddd;
    border-collapse: collapse;
    font-size: 13px;
  }

  .tdCSS1 {
    width: 40px;
    padding: 3px;
    text-align: left;
    border: none;
    font-size: 13px;
  }

  .tdCSS {
    padding: 3px;
    text-align: left;
    border: none;
    font-size: 13px;
  }


  /* 其他 */
  .margintop {
    margin-left: auto;
    margin-right: auto;
    /* margin-top: 95px; */
  }

  .tiaozhuan {
    margin-top: 100px;
    text-align: left;
    margin-bottom: 0.83em;
    margin-left: 2%;
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/xueyuan.vue